module.exports = MemberJoinLabels;